/**
 * Plain wording for what an ad gives the player. English only for now; the
 * other languages fall back to this until the owner approves translations.
 */
export const AD_COPY = {
  /** Under the extra life button on the run over card. */
  life_note: 'Watching one short ad gives you 1 extra life. It is your choice. You can bank your run instead.',
  /** Settings sheet, always visible. */
  about_title: 'ABOUT ADS',
  about_body:
    'NØDUS is free and shows ads. Between endless levels an ad can appear, never in the first four levels, never in a tutorial, never right after a failed level, and not more than once every 3 minutes. ' +
    'A hint or an extra life only plays an ad if you tap it, and you can say no.',
} as const;
